export const boletines_item = [
   {
        "boletines_item_titulo" : "Boletín 28 2025",
        "boletines_item_nombre" : "En junio, Hidalgo fue la tercera entidad a nivel nacional con menor tasa de desocupación",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_28.pdf"
    },{
        "boletines_item_titulo" : "Boletín 27 2025",
        "boletines_item_nombre" : "Feria del Empleo en Mineral de la Reforma impulsa el trabajo formal y la reactivación económica local",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_27.pdf"
    },{
        "boletines_item_titulo" : "Boletín 26 2025",
        "boletines_item_nombre" : "Acercan opciones de trabajo a buscadores de empleo en Tlaxcoapan",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_26.pdf"
    },{
        "boletines_item_titulo" : "Boletín 25 2025",
        "boletines_item_nombre" : "STPSH coloca a trabajadores en empresas agrícolas formales",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_25.pdf"
    },{
        "boletines_item_titulo" : "Boletín 24 2025",
        "boletines_item_nombre" : "Empresas, aliadas estratégicas en el fortalecimiento del empleo en Hidalgo: STPSH",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_24.pdf"
    },{
        "boletines_item_titulo" : "Boletín 23 2025",
        "boletines_item_nombre" : "Secretaría del Trabajo anuncia vacantes en periódico digital",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_23.pdf"
    },{
        "boletines_item_titulo" : "Boletín 22 2025",
        "boletines_item_nombre" : "Hidalgo fortalece la inclusión laboral con enfoque en grupos vulnerables",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_22.pdf"
    },{
        "boletines_item_titulo" : "Boletín 21 2025",
        "boletines_item_nombre" : "Secretaría del Trabajo realiza pláticas de sensibilización contra el trabajo infantil",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_21.pdf"
    },{
        "boletines_item_titulo" : "Boletín 20 2025",
        "boletines_item_nombre" : "Se ofertaron 560 plazas en la Feria Nacional de Empleo en Atitalaquia",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_20.pdf"
    },{
        "boletines_item_titulo" : "Boletín 19 2025",
        "boletines_item_nombre" : "STPSH invita a empresas a realizar el pago de utilidades",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_19.pdf"
    },{
        "boletines_item_titulo" : "Boletín 18 2025",
        "boletines_item_nombre" : "STPSH y CANACO Servytur Pachuca impulsan el empleo con Expo Talento Hidalgo 2025",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_18.pdf"
    },{
        "boletines_item_titulo" : "Boletín 17 2025",
        "boletines_item_nombre" : "STPSH firma convenios con los ayuntamientos de Mineral del Monte y Omitlán de Juárez",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_17.pdf"
    },{
        "boletines_item_titulo" : "Boletín 16 2025",
        "boletines_item_nombre" : "Gobierno de Hidalgo concientiza sobre el trabajo infantil",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_16.pdf"
    },{
        "boletines_item_titulo" : "Boletín 15 2025",
        "boletines_item_nombre" : "STPSH fortalece acciones para el sector laboral en Tepeji",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_15.pdf"
    },{
        "boletines_item_titulo" : "Boletín 14 2025",
        "boletines_item_nombre" : "Hidalgo, segundo lugar nacional por mayor reducción de desempleo",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_14.pdf"
    },{
        "boletines_item_titulo" : "Boletín 13 2025",
        "boletines_item_nombre" : "Pago de utilidades derecho de las y los trabajadores",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_13.pdf"
    },{
        "boletines_item_titulo" : "Boletín 12 2025",
        "boletines_item_nombre" : "En marcha programas de apoyo, dirigido a buscadores de empleo",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_12.pdf"
    },{
        "boletines_item_titulo" : "Tarjeta Informativa 01 2025",
        "boletines_item_nombre" : "Manifestación de trabajadores de Huehuetla",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/TI_01.pdf"
    },{
        "boletines_item_titulo" : "Boletín 11 2025",
        "boletines_item_nombre" : "En febrero disminuyó tasa de desempleo en Hidalgo",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_11.pdf"
    },{
        "boletines_item_titulo" : "Boletín 10 2025",
        "boletines_item_nombre" : "Trabajadores agrícolas hidalguenses reciben taller sobre sus derechos laborales al colocarse en una empresa canadiense",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_10.pdf"
    },{
        "boletines_item_titulo" : "Boletín 09 2025",
        "boletines_item_nombre" : "Feria de Empleo Nacional para las Mujeres promueve la inclusión laboral",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_09.pdf"
    },{
        "boletines_item_titulo" : "Boletín 08 2025",
        "boletines_item_nombre" : "Feria Nacional de Empleo promueve participación de mujeres en el sector laboral",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_08.pdf"
    },{
        "boletines_item_titulo" : "Boletín 07 2025",
        "boletines_item_nombre" : "Incrementa participación femenina en sector laboral",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_07.pdf"
    },{
        "boletines_item_titulo" : "Boletín 06 2025",
        "boletines_item_nombre" : "Recomendaciones para una entrevista de trabajo",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_06.pdf"
    },{
        "boletines_item_titulo" : "Boletín 05 2025",
        "boletines_item_nombre" : "Expo Laboral en Mixquiahuala, fortalece economía local con empleo formal",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_05.pdf"
    },{
        "boletines_item_titulo" : "Boletín 04 2025",
        "boletines_item_nombre" : "Hidalgo muestra recuperación en el empleo formal, de acuerdo con datos del IMSS",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_04.pdf"
    },{
        "boletines_item_titulo" : "Boletín 03 2025",
        "boletines_item_nombre" : "STPSH alerta sobre características de vacantes fraudulentas",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_03.pdf"
    },{
        "boletines_item_titulo" : "Boletín 02 2025",
        "boletines_item_nombre" : "STPSH cuenta con servicios de vinculación laboral y concertación empresarial gratuitos",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_02.pdf"
    },{
        "boletines_item_titulo" : "Boletín 01 2025",
        "boletines_item_nombre" : "En 2025 serán siete días feriados de acuerdo con la Ley Federal del Trabajo",
        "boletines_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/boletines/2025/Boletin_01.pdf"
    }
]